import FooterCard from './FooterCard';

export { type FooterCardProps } from './FooterCard';
export default FooterCard;
